module.exports = __webpack_public_path__ + "img/selected3-min.5ebd6b86.png";